import { useEffect, useState } from "react";
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Breadcrumb from '../Component/Breadcrumb';
import { getCircular } from '../Service/Api';

function Syllabus() {
    const [syllabusData, setSyllabusData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const circularData = await getCircular();
                const filtered = circularData
                    .filter(item => item.category === "Syllabus")
                    .sort((a, b) => new Date(b.date) - new Date(a.date)); // Latest first
                setSyllabusData(filtered);
            } catch (error) {
                console.error("Error fetching syllabus data:", error);
            }
        };
        fetchData();
    }, []);

    return (
        <>
            <Header />
            <Breadcrumb title="Syllabus" midBreadcrumb="Academic" mainBreadcrumb="Syllabus" />
            <div className='inner-page'>
                <div className="container my-4">
                    <h2 className="mainhead">Syllabus</h2>
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Class</th>
                                <th>Subjects</th>
                                <th>Date</th>
                                <th>View / Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {syllabusData.length > 0 ? (
                                syllabusData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.class || "Class"}</td>
                                        <td>{item.title || "Subjects"}</td>
                                        <td>{item.date ? new Date(item.date).toLocaleDateString() : "N/A"}</td>
                                        <td>
                                            {item.attachments?.[0] ? (
                                                <a
                                                    href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Download
                                                </a>
                                            ) : (
                                                "N/A"
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">No syllabus data available.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Syllabus;
